import { Injectable } from '@angular/core';
import { CollectionHelper } from '../helpers/collection-helper';
import { StringHelper } from '../helpers/string-helper';

@Injectable({
  providedIn: 'root'
})
export class OfflineStorageTimestampService {
  private readonly EXPIRY_DIFF = 86400000; // 24 hours

  public setTimestamps(collectionKey: string, items: TimestampItem[]) {
    if (StringHelper.isEmpty(collectionKey)) {
      throw new Error('collectionKey must not be empty');
    }
    if (!CollectionHelper.isPopulated(items)) {
      return;
    }
    const storedItems = localStorage.getItem(collectionKey);
    const map = new Map<string, TimestampItem>();
    if (!StringHelper.isEmpty(storedItems)) {
      const storedArray = <TimestampItem[]>JSON.parse(storedItems);
      if (CollectionHelper.isPopulated(storedArray)) {
        storedArray.forEach(e => map.set(e.key, e));
      }
    }
    items.forEach(i => map.set(i.key, i));
    const toStore: TimestampItem[] = [];
    map.forEach(e => toStore.push(e));
    localStorage.setItem(collectionKey, JSON.stringify(toStore));
  }

  public getExpiredItems(collectionKey: string): TimestampItem[] {
    if (StringHelper.isEmpty(collectionKey)) {
      throw new Error('collectionKey must not be empty');
    }
    const timestampItems = localStorage.getItem(collectionKey);
    if (timestampItems == null) {
      return [];
    }
    let parsedTimestampItems = <TimestampItem[]>JSON.parse(timestampItems);
    if (!CollectionHelper.isPopulated(parsedTimestampItems)) {
      return [];
    }
    const now = Date.now();
    CollectionHelper.filterInPlace(
      parsedTimestampItems,
      i => now - i.timestamp >= this.EXPIRY_DIFF
    );
    return parsedTimestampItems;
  }

  public removeItems(collectionKey: string, itemKeys: string[]): void {
    if (StringHelper.isEmpty(collectionKey)) {
      throw new Error('collectionKey must not be empty');
    }
    if (!CollectionHelper.isPopulated(itemKeys)) {
      return;
    }
    const timestampItems = localStorage.getItem(collectionKey);
    if (timestampItems == null) {
      return;
    }
    let parsedTimestampItems = <TimestampItem[]>JSON.parse(timestampItems);
    if (!CollectionHelper.isPopulated(parsedTimestampItems)) {
      return;
    }
    CollectionHelper.filterInPlace(
      parsedTimestampItems,
      i => !itemKeys.includes(i.key)
    );
    localStorage.setItem(collectionKey, JSON.stringify(parsedTimestampItems));
  }
}

interface TimestampItem {
  key: string;
  timestamp: number;
}
